import {IStationUser, MinimalUserModel, StationUserStatus} from '@core/api/data-access';

import {StationModel} from '../../models';

export class StationUserModel implements IStationUser {
	user: string;
	userModel: MinimalUserModel;
	status: StationUserStatus;
	timestamp?: Date;

	/* ---------------------------------- Added --------------------------------- */
	fullname: string;
	stationRef: StationModel;

	constructor(init?: IStationUser, stationRef?: StationModel) {
		if (init) {
			Object.assign(this, init);
			if (init.userModel) this.userModel = new MinimalUserModel(init.userModel);
		}
		this.stationRef = stationRef;
	}

	/* -------------------------------------------------------------------------- */
	/*                               Spacial Getters                              */

	/* -------------------------------------------------------------------------- */

	toJSON(): IStationUser {
		return {
			user: this.user,
			status: this.status,
			timestamp: this.timestamp,
		};
	}
}
